
/**
 * This class is abstract class for modals.
 */
export default class BaseModal {

  constructor() {
  }

  /**
   * This function initialize the modal.
   */
  initModal() {}

  /**
   * This function checks if the model element exists.
   *
   * @param {string} modalSelector modal element selector
   * @returns {boolean} true if the modal element exists.
   */
  modalExists(modalSelector) {
    return $(modalSelector).length > 0;
  }
}
